import { Row, Col, Layout } from 'antd';
import AdminApprovalComponent from '../Organism/AdminApprovalComponent';
const { Content } = Layout;



const AdminApproval: React.FC = () => {

  return (
    <Layout style={{ backgroundColor: 'white' }}>
        <Content style={{ padding: '0 10px',backgroundColor: 'white' }}>
          <AdminApprovalComponent />
        </Content>
    </Layout>
  );
};

export default AdminApproval;